export interface ResponseNotificationPreferences {
  notifySystem?: boolean;
  notifyResponses?: 'never' | 'background' | 'always';
}

export function browserNotificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

/** Só deve ser chamada por um gesto explícito do usuário, nunca na montagem. */
export async function ensureBrowserNotificationPermission(): Promise<boolean> {
  if (!browserNotificationsSupported()) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  return (await Notification.requestPermission()) === 'granted';
}

/** Entrega a conclusão respeitando sistema, permissão e a escolha "fora de foco". */
export function notifyResponseCompleted(
  preferences: ResponseNotificationPreferences | undefined,
  body: string,
): void {
  if (!browserNotificationsSupported() || Notification.permission !== 'granted') return;
  if (!preferences?.notifySystem || preferences.notifyResponses === 'never') return;
  if (preferences.notifyResponses === 'background' && document.visibilityState === 'visible') return;
  try {
    new Notification('Resposta concluída — Shiba IA', { body, icon: '/favicon.png', tag: 'shiba-response' });
  } catch {
    // A preferência permanece salva; um bloqueio do SO não quebra a resposta.
  }
}
